/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FunctionScoreAction } from './FunctionScoreAction';
import {
    FunctionScoreActionFromJSON,
    FunctionScoreActionFromJSONTyped,
    FunctionScoreActionToJSON,
} from './FunctionScoreAction';
import type { GgFunctionScorePredictedScore } from './GgFunctionScorePredictedScore';
import {
    GgFunctionScorePredictedScoreFromJSON,
    GgFunctionScorePredictedScoreFromJSONTyped,
    GgFunctionScorePredictedScoreToJSON,
} from './GgFunctionScorePredictedScore';
import type { GgFunctionScoreScore } from './GgFunctionScoreScore';
import {
    GgFunctionScoreScoreFromJSON,
    GgFunctionScoreScoreFromJSONTyped,
    GgFunctionScoreScoreToJSON,
} from './GgFunctionScoreScore';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
} from './VisualReference';

/**
 * 
 * @export
 * @interface GgFunctionScore
 */
export interface GgFunctionScore {
    /**
     * 
     * @type {FunctionScoreAction}
     * @memberof GgFunctionScore
     */
    action: FunctionScoreAction;
    /**
     * 
     * @type {GgFunctionScoreScore}
     * @memberof GgFunctionScore
     */
    score: GgFunctionScoreScore | null;
    /**
     * 
     * @type {GgFunctionScorePredictedScore}
     * @memberof GgFunctionScore
     */
    predicted_score?: GgFunctionScorePredictedScore | null;
    /**
     * 
     * @type {string}
     * @memberof GgFunctionScore
     */
    readonly reasoning?: string | null;
    /**
     * 
     * @type {Array<VisualReference>}
     * @memberof GgFunctionScore
     */
    visual_references?: Array<VisualReference>;
}

/**
 * Check if a given object implements the GgFunctionScore interface.
 */
export function instanceOfGgFunctionScore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "score" in value;

    return isInstance;
}

export function GgFunctionScoreFromJSON(json: any): GgFunctionScore {
    return GgFunctionScoreFromJSONTyped(json, false);
}

export function GgFunctionScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): GgFunctionScore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': FunctionScoreActionFromJSON(json['action']),
        'score': GgFunctionScoreScoreFromJSON(json['score']),
        'predicted_score': !exists(json, 'predicted_score') ? undefined : GgFunctionScorePredictedScoreFromJSON(json['predicted_score']),
        'reasoning': !exists(json, 'reasoning') ? undefined : json['reasoning'],
        'visual_references': !exists(json, 'visual_references') ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function GgFunctionScoreToJSON(value?: GgFunctionScore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': FunctionScoreActionToJSON(value.action),
        'score': GgFunctionScoreScoreToJSON(value.score),
        'predicted_score': GgFunctionScorePredictedScoreToJSON(value.predicted_score),
        'visual_references': value.visual_references === undefined ? undefined : ((value.visual_references as Array<any>).map(VisualReferenceToJSON)),
    };
}

